<template>
  <div class="page page--center">
    <h1 class="page__title">Медстрим.онлайн</h1>

    <article class="page__content">
        <content-editor v-model="page.description" :options="options" :controls="false"></content-editor>
    </article>

    <h2 class="page__subtitle">Наши курсы</h2>
    <article class="page__courses courses">
      <course-card v-for="course in courses" :key="course.id" :course="course"></course-card>
    </article>

    <div class="promo">
      <a href="/partnership" class="promo__button button button--blue button--uppercase">Создайте собственный курс</a>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CourseCard from '../components/CourseCard';
  import ContentEditor from '../components/ContentEditor';

  export default {
    components: {
      CourseCard,
      ContentEditor,
    },
    metaInfo () {
      return {
        title: 'Главная',
      }
    },
    data: () => ({
      options: {
        postImageUrl: '',
        baseImagePath: '/images/pages/main',
        baseFilePath: '/files/pages/main',
      },
    }),
    computed: {
      ...mapGetters({
        courses: 'courses/courses',
        page: 'pages/page',
      }),
    },
    async beforeMount () {
      this.$store.dispatch('pages/clearPage');
      this.$store.dispatch('pages/find', 'main').then(() => {
        this.$store.dispatch('pages/stopLoading');
      });
      this.$store.dispatch('courses/fetchAll');

      this.$store.dispatch('pages/setBreadcrumbs', [
        {
          title: 'Главная',
        }
      ]);

      this.$store.dispatch('pages/setControls', [
        {
          url: '/admin/pages/main',
          label: 'Редактировать',
          roles: ['admin']
        }
      ]);
    }
  }
</script>
